import { createApp } from "vue";
import App from "./App.vue";
import router from "./router"; // Make sure the router is imported

createApp(App)
  .use(router) // Use the router
  .mount("#app");
